/* eslint-disable no-console */
const isPrimitiveValue = (value) => {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
};
const isPlainObject = (possibleObject) => {
    return (typeof possibleObject === 'object' &&
        possibleObject !== null &&
        !Array.isArray(possibleObject) &&
        !(possibleObject instanceof Function));
};
const isAcceptedContextObject = (value) => {
    if (!isPlainObject(value)) {
        return false;
    }
    const areAllValuesPrimitive = Object.values(value).every(isPrimitiveValue);
    return areAllValuesPrimitive;
};
/**
 * Datadog RUM already collects the following attributes for each error. To create our context of
 * other properties, we should exclude these attributes.
 * More information: https://docs.datadoghq.com/real_user_monitoring/browser/collecting_browser_errors/?tab=npm#error-attributes
 */
const DATADOG_RUM_DEFAULT_TRACKED_ATTRIBUTES = ['source', 'type', 'message', 'stack'];
const isAcceptedErrorAttribute = (key, error) => {
    if (DATADOG_RUM_DEFAULT_TRACKED_ATTRIBUTES.includes(key)) {
        return false;
    }
    const value = error[key];
    return isPrimitiveValue(value) || isAcceptedContextObject(value);
};
export const getSafeErrorContext = (error) => {
    try {
        const safeContext = Object.fromEntries(Object.entries(error).filter(([key]) => isAcceptedErrorAttribute(key, error)));
        return safeContext;
    }
    catch (errorFromContext) {
        console.warn(`[Logger] Failed to extract error context due to: ${errorFromContext instanceof Error ? errorFromContext.message : errorFromContext}. Original error: ${error.message}. Returning empty context object.`);
        return {};
    }
};
export const getSafeUserContext = (context) => {
    try {
        const allowedEntries = Object.entries(context).filter(([, value]) => isPrimitiveValue(value) || isAcceptedContextObject(value));
        const safeContext = Object.fromEntries(allowedEntries);
        return safeContext;
    }
    catch (errorFromContext) {
        console.warn(`[Logger] Failed to extract user context due to: ${errorFromContext instanceof Error ? errorFromContext.message : errorFromContext}. Returning empty context object.`);
        return {};
    }
};
